import { initSentry } from '@/helpers/sentryInit';
import domus, { HgSupportedLanguage, SupportedPlatforms } from '@smg-real-estate/domus';
import { createHead } from '@unhead/vue/client';
import { createApp } from 'vue';

import { initBrowserRum } from '@/datadog-client-setup';
import App from './AppHg.vue';
import { createI18n } from './i18n-setup-hg';
import createRouter from './router';
import store from './store/store';

// Base setup
const router = createRouter(HgSupportedLanguage.DE);
const i18n = createI18n();
const head = createHead();
const app = createApp(App);

// Plugins
app.use(store);
app.use(router);
app.use(head);
app.use(i18n);
app.use(domus, {
  theme: SupportedPlatforms.hg,
  i18n: { instance: i18n, languages: { name: 'all', mode: 'lazy' } },
  router: { instance: router, defaultLanguage: HgSupportedLanguage.DE },
});

// Sentry;
initSentry(app, { allowUrls: [/homegate\.ch/, /\.homegate\.ch/] });
initBrowserRum();

router.isReady().then(() => {
  app.mount('#app');
});
